import React, { useState, useRef, useEffect } from 'react';
import { Download, UploadCloud, FileText, Loader2, Save, X, CheckSquare, Image as ImageIcon } from 'lucide-react';

export const PropostaBuilder: React.FC = () => {
  const [nomeEmpresa, setNomeEmpresa] = useState('Nome do Cliente');
  const [nomeAgencia, setNomeAgencia] = useState('NYROH');
  const [cnpj, setCnpj] = useState('00.000.000/0001-00');
  const [contato, setContato] = useState('(00) 00000-0000');
  const [email, setEmail] = useState('contato@nyroh.com.br');
  const [logoUrl, setLogoUrl] = useState('');
  const [coverUrl, setCoverUrl] = useState('https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80&w=2670');
  const [colorHex, setColorHex] = useState('#0066cc'); // Default NYROH blue
  const [fontFamily, setFontFamily] = useState('Inter'); // Default
  const logoInputRef = useRef<HTMLInputElement>(null);
  const coverInputRef = useRef<HTMLInputElement>(null);

  const handlePrint = () => {
    window.print();
  };

  const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setLogoUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleCoverUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setCoverUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  
  return (
    <div className="flex w-full gap-6 max-h-[85vh] no-print">
      {/* LEFT PANE - Controls (20% to 25%) */}
      <div className="w-1/4 min-w-[280px] bg-white rounded-xl border border-gray-200 shadow-sm flex flex-col h-full overflow-hidden shrink-0">
        <div className="p-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center shrink-0">
          <h2 className="font-semibold text-gray-900 flex items-center gap-2"><FileText size={18} /> Editor de Proposta</h2>
        </div>
        
        <div className="flex-1 overflow-y-auto p-4 space-y-6 scrollbar-hide">
          <div className="space-y-3">
             <h3 className="text-xs font-bold uppercase tracking-widest text-neutral-400">Cliente</h3>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Nome do Cliente</label>
               <input type="text" value={nomeEmpresa} onChange={e => setNomeEmpresa(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black" placeholder="Ex: Vidraam" />
             </div>
          </div>
          
          <hr className="border-gray-100" />
          
          <div className="space-y-3">
             <h3 className="text-xs font-bold uppercase tracking-widest text-neutral-400">Personalização</h3>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Cor Principal (HEX)</label>
               <div className="flex items-center gap-2">
                 <input type="color" value={colorHex} onChange={e => setColorHex(e.target.value)} className="w-8 h-8 rounded cursor-pointer border-0 p-0" />
                 <input type="text" value={colorHex} onChange={e => setColorHex(e.target.value)} className="flex-1 text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black font-mono uppercase" />
               </div>
             </div>
             
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Fonte Principal</label>
               <select value={fontFamily} onChange={e => setFontFamily(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black">
                 <option value="Inter">Inter (Clean / Tech)</option>
                 <option value="Space Grotesk">Space Grotesk (Moderno)</option>
                 <option value="Outfit">Outfit (Arrojado)</option>
                 <option value="Playfair Display">Playfair (Editorial)</option>
               </select>
             </div>
             
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Fundo da Capa</label>
               <div className="flex items-center gap-2">
                 <button onClick={() => coverInputRef.current?.click()} className="flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg px-3 py-2 transition-colors border border-gray-200 w-full text-sm font-medium">
                   <ImageIcon size={16} className="mr-2" /> Fazer Upload
                 </button>
                 <input type="file" accept="image/*" className="hidden" ref={coverInputRef} onChange={handleCoverUpload} />
               </div>
             </div>
             
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Sua Logo</label>
               <div className="flex items-center gap-2">
                 <button onClick={() => logoInputRef.current?.click()} className="flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg px-3 py-2 transition-colors border border-gray-200 w-full text-sm font-medium">
                   <UploadCloud size={16} className="mr-2" /> Fazer Upload
                 </button>
                 <input type="file" accept="image/*" className="hidden" ref={logoInputRef} onChange={handleLogoUpload} />
               </div>
               {logoUrl && <button onClick={() => setLogoUrl('')} className="mt-1 text-xs text-red-600 hover:underline">Remover logo</button>}
             </div>
          </div>

          <hr className="border-gray-100" />

          <div className="space-y-3">
             <h3 className="text-xs font-bold uppercase tracking-widest text-neutral-400">Seus Dados</h3>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Nome da Marca</label>
               <input type="text" value={nomeAgencia} onChange={e => setNomeAgencia(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black" />
             </div>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">CNPJ</label>
               <input type="text" value={cnpj} onChange={e => setCnpj(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black" />
             </div>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">Contato (WhatsApp)</label>
               <input type="text" value={contato} onChange={e => setContato(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black" />
             </div>
             <div>
               <label className="block text-xs font-medium text-gray-700 mb-1">E-mail</label>
               <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2 outline-none focus:border-black" />
             </div>
          </div>
        </div>
        
        <div className="p-4 border-t border-gray-100 bg-gray-50 flex flex-col gap-2 shrink-0">
          <button 
            onClick={handlePrint}
            className="w-full bg-black hover:bg-gray-800 text-white py-2.5 rounded-lg text-sm font-medium transition-colors flex justify-center items-center gap-2 shadow-sm"
          >
            <Download size={16} /> Salvar como PDF
          </button>
          <p className="text-[10px] text-gray-500 text-center leading-tight mt-1">Dica: No menu de impressão, escolha "Salvar como PDF" e remova margens/cabeçalhos.</p>
        </div>
      </div>
      
      {/* RIGHT PANE - Preview (80%) */}
      <div className="flex-1 bg-gray-200/50 rounded-xl border border-gray-200 overflow-y-auto p-8 flex justify-center shadow-inner relative print:p-0 print:absolute print:inset-0 print:bg-white print:z-50 print:overflow-visible">
        
        {/* Document Content - A4 Proporcao */}
        <div 
          className="w-full max-w-[210mm] bg-white shadow-lg print:shadow-none print:m-0 shrink-0 text-gray-900 pb-20 printable-document relative z-10 print:w-screen"
          style={{ fontFamily: fontFamily === 'Inter' ? '"Inter", sans-serif' : fontFamily === 'Space Grotesk' ? '"Space Grotesk", sans-serif' : fontFamily === 'Outfit' ? '"Outfit", sans-serif' : fontFamily === 'Playfair Display' ? '"Playfair Display", serif' : '"Inter", sans-serif' }}
          contentEditable={true}
          suppressContentEditableWarning={true}
        >
           
           {/* CAPA */}
           <div className="w-full h-[297mm] min-h-[1122px] relative flex flex-col items-center justify-center text-center overflow-hidden break-after-page text-white px-20">
             <div className="absolute inset-0 z-0">
               <div className="absolute inset-0 z-10" style={{ backgroundColor: colorHex, opacity: 0.85 }}></div>
               <img src={coverUrl} alt="Cover" className="w-full h-full object-cover" />
             </div>
             
             <div className="relative z-20 flex flex-col items-center w-full h-full py-20 justify-between">
               
               <div>
                 {logoUrl ? (
                   <img src={logoUrl} alt="Logo" className="h-24 object-contain mb-8" />
                 ) : (
                   <h1 className="text-6xl font-black tracking-tighter mb-8 text-white">{nomeAgencia}</h1>
                 )}
               </div>
               
               <div className="max-w-2xl mx-auto space-y-6">
                 <h2 className="text-3xl font-medium tracking-tight border-b border-white/20 pb-6">
                   Sistema integrado de aquisição e atendimento digital
                 </h2>
                 
                 <p className="text-xl font-light text-gray-200 leading-relaxed">
                   Tráfego, conteúdo, site e atendimento automatizado em uma única estrutura operacional
                 </p>
                 
                 <p className="text-sm font-medium text-gray-400 mt-4 uppercase tracking-widest">
                   Um novo modelo de entrega baseado em eficiência, integração e escala
                 </p>
               </div>
               
               <div className="border-t border-white/20 pt-8 w-full max-w-sm mt-12">
                 <p className="text-sm text-gray-400 font-medium tracking-widest uppercase mb-2">Proposta Exclusiva Para</p>
                 <p className="text-3xl font-bold">{nomeEmpresa}</p>
                 <p className="text-sm mt-4 text-gray-400 font-mono">{new Date().toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</p>
               </div>
             </div>
           </div>

           {/* SECAO 1: VISÃO DE MERCADO */}
           <div className="p-20 break-after-page space-y-16 mt-12 min-h-[1100px]">
              <div className="border-l-4 pl-8" style={{ borderColor: colorHex }}>
                <h2 className="text-4xl font-bold tracking-tight mb-2">A Mudança Sutil do mercado</h2>
                <p className="text-xl text-gray-500 font-light">O marketing evoluiu junto a tecnlogia</p>
              </div>
              
              <div className="space-y-6 text-xl leading-relaxed text-gray-700">
                <p>Hoje dá para fazer mais rápido, com menos custo e mais eficiência.</p>
                <p>Mesmo assim, a maioria das empresas ainda usa serviços separados e sem integração.</p>
                <p className="font-semibold text-gray-900">Isso gera mais custo e menos resultado.</p>
                <p>A <strong style={{color: colorHex}}>{nomeAgencia}</strong> nasce para unir tudo em um único sistema mais simples e eficiente.</p>
              </div>

              <hr className="border-gray-200 my-16" />

              <div className="border-l-4 pl-8 border-gray-300">
                <h2 className="text-4xl font-bold tracking-tight mb-2">Problema do modelo tradicional</h2>
              </div>
              
              <div className="space-y-6 text-xl leading-relaxed text-gray-700">
                <p>No modelo tradicional, o foco está em margem alta por serviço.</p>
                <p>Cada parte é vendida separadamente, o que aumenta o custo total para o cliente.</p>
                <p>Mesmo quando existe automação ou ganho de eficiência, isso raramente é repassado.</p>
                <p className="font-semibold text-red-800 bg-red-50 p-6 rounded-lg border border-red-100 shadow-sm mt-8">
                  O resultado é um modelo mais caro, menos integrado e pouco eficiente para quem contrata.
                </p>
              </div>
           </div>

           {/* SECAO 2: VISÃO E SIMPLICIDADE */}
           <div className="p-20 break-after-page mt-12 min-h-[1100px]">
              <div className="border-l-4 pl-8" style={{ borderColor: colorHex }}>
                <h2 className="text-4xl font-bold tracking-tight mb-2">Visão {nomeAgencia}</h2>
              </div>
              
              <div className="space-y-6 text-xl leading-relaxed text-gray-700 mt-12">
                <p>A <strong style={{color: colorHex}}>{nomeAgencia}</strong> nasce com uma lógica diferente.</p>
                <p>Em vez de capturar eficiência para aumentar margem, o foco é reduzir complexidade e custo para o cliente.</p>
                <p>Com processos estruturados e automação, conseguimos entregar tudo de forma integrada e mais eficiente.</p>
                <p className="font-semibold bg-gray-50 p-6 rounded-xl border border-gray-100 shadow-sm mt-8 text-black">
                  O resultado é um sistema completo, com melhor execução e menor fricção operacional.
                </p>
              </div>

              <hr className="border-gray-200 my-16" />

              <div className="border-l-4 pl-8" style={{ borderColor: colorHex }}>
                <h2 className="text-4xl font-bold tracking-tight mb-2">Simplicidade: modelo integrado</h2>
              </div>
              
              <div className="space-y-6 text-xl leading-relaxed text-gray-700 mt-12">
                <p>A <strong style={{color: colorHex}}>{nomeAgencia}</strong> funciona como um sistema único de aquisição e atendimento.</p>
                <p>Em vez de serviços separados, tudo opera conectado em uma única estrutura:</p>
                
                <ul className="space-y-5 my-10 list-none ml-4">
                  <li className="flex items-center gap-4"><div className="w-3 h-3 rounded-full" style={{backgroundColor: colorHex}}></div><strong>Tráfego pago (Meta e Google)</strong> gera os leads</li>
                  <li className="flex items-center gap-4"><div className="w-3 h-3 rounded-full" style={{backgroundColor: colorHex}}></div><strong>Conteúdo</strong> reforça autoridade e intenção</li>
                  <li className="flex items-center gap-4"><div className="w-3 h-3 rounded-full" style={{backgroundColor: colorHex}}></div><strong>Site</strong> organiza e converte o interesse</li>
                  <li className="flex items-center gap-4"><div className="w-3 h-3 rounded-full" style={{backgroundColor: colorHex}}></div><strong>WhatsApp com IA</strong> qualifica e direciona o atendimento</li>
                </ul>

                <div className="bg-gray-900 text-white p-10 rounded-2xl shadow-xl mt-12">
                  <p className="font-bold mb-6 uppercase tracking-widest text-sm text-gray-400">Resultado:</p>
                  <ul className="space-y-4 font-medium text-lg">
                    <li className="flex items-start gap-3">✓ Um fluxo contínuo do anúncio até a venda</li>
                    <li className="flex items-start gap-3">✓ Menos perda de leads</li>
                    <li className="flex items-start gap-3">✓ Processo centralizado e mais eficiente</li>
                    <li className="flex items-start gap-3">✓ Operação simples para o cliente acompanhar e escalar</li>
                  </ul>
                </div>
              </div>
           </div>

           {/* SECAO 3: ESTRUTURA DOS SERVICOS */}
           <div className="p-20 break-after-page mt-12 min-h-[1100px]">
               <h2 className="text-4xl font-bold tracking-tight mb-8 text-center pt-8">Estrutura dos serviços</h2>
               <p className="text-xl text-center mb-16 text-gray-600">O sistema {nomeAgencia} é formado por quatro pilares integrados:</p>
               
               <div className="grid grid-cols-2 gap-10 mb-16">
                 <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden">
                   <div className="absolute top-0 left-0 w-full h-1" style={{backgroundColor: colorHex}}></div>
                   <h3 className="font-bold text-2xl mb-4" style={{color: colorHex}}>Tráfego pago (Meta e Google)</h3>
                   <p className="text-lg text-gray-600 leading-relaxed">Campanhas sempre em teste de criativos para identificar o que performa melhor, seguidas de processo de escala. Inclui estrutura de remarketing integrada entre Google e Meta (Instagram) para recuperar e impactar novamente os leads.</p>
                 </div>
                 <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden">
                   <div className="absolute top-0 left-0 w-full h-1" style={{backgroundColor: colorHex}}></div>
                   <h3 className="font-bold text-2xl mb-4" style={{color: colorHex}}>Conteúdo para redes sociais</h3>
                   <p className="text-lg text-gray-600 leading-relaxed">Produção de conteúdo base para reforçar autoridade, gerar confiança e apoiar as campanhas de tráfego.</p>
                 </div>
                 <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden">
                   <div className="absolute top-0 left-0 w-full h-1" style={{backgroundColor: colorHex}}></div>
                   <h3 className="font-bold text-2xl mb-4" style={{color: colorHex}}>Site de conversão</h3>
                   <p className="text-lg text-gray-600 leading-relaxed">Estrutura focada em transformar visitas em leads, com foco em clareza e direcionamento para ação.</p>
                 </div>
                 <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden">
                   <div className="absolute top-0 left-0 w-full h-1" style={{backgroundColor: colorHex}}></div>
                   <h3 className="font-bold text-2xl mb-4" style={{color: colorHex}}>SDR com IA no WhatsApp</h3>
                   <p className="text-lg text-gray-600 leading-relaxed">Atendimento automatizado para responder rapidamente, qualificar os leads e direcionar para o fechamento.</p>
                 </div>
               </div>
               
               <div className="text-center bg-gray-50 p-6 rounded-xl border border-gray-200 shadow-sm">
                  <p className="font-bold text-2xl tracking-tight text-gray-900">Tudo opera de forma conectada dentro de um único sistema.</p>
               </div>
           </div>

           {/* SECAO 4: FUNCIONAMENTO E PRINCIPIOS */}
           <div className="p-20 break-after-page min-h-[1100px] mt-12 bg-white">
               <h2 className="text-4xl font-bold tracking-tight mb-10 pt-8">Funcionamento prático</h2>
               <p className="text-xl mb-10 text-gray-700">O sistema <strong style={{color: colorHex}}>{nomeAgencia}</strong> funciona como um fluxo contínuo de aquisição e atendimento:</p>
               
               <div className="pl-8 border-l-4 border-gray-200 space-y-5 mb-12 text-xl text-gray-800">
                 <p>• O tráfego gera visitas e leads qualificados</p>
                 <p>• O site organiza a oferta e direciona a ação</p>
                 <p>• O WhatsApp com IA responde automaticamente e qualifica o interesse</p>
                 <p>• Os leads mais quentes são direcionados para fechamento</p>
               </div>
               
               <p className="text-2xl font-bold mb-6 text-gray-900">Enquanto isso:</p>
               <div className="pl-8 border-l-4 space-y-5 mb-16 text-xl text-gray-800" style={{ borderColor: colorHex }}>
                 <p>• As campanhas passam por testes constantes de criativos</p>
                 <p>• Os melhores anúncios são escalados</p>
                 <p>• O remarketing atua entre Meta e Google para recuperar interessados</p>
               </div>

               <p className="text-2xl font-semibold bg-gray-900 text-white py-8 px-10 rounded-2xl text-center shadow-lg mb-20">
                 Resultado: um fluxo constante de entrada, qualificação e conversão de clientes.
               </p>

               <hr className="border-gray-200 mb-16" />

               <h2 className="text-4xl font-bold tracking-tight mb-10">Princípios de tráfego e operação</h2>
               <p className="text-xl mb-10 text-gray-700">O tráfego dentro da <strong style={{color: colorHex}}>{nomeAgencia}</strong> segue uma lógica contínua de otimização e eficiência:</p>
               
               <ul className="space-y-6 mb-16 text-xl text-gray-700 list-disc list-inside bg-gray-50 p-10 rounded-2xl border border-gray-100">
                 <li>Campanhas sempre iniciam com testes de criativos para identificar o que gera melhor resultado</li>
                 <li>Os melhores anúncios são escalados de forma progressiva</li>
                 <li>O desempenho é ajustado com base em dados reais, não em suposições</li>
                 <li>O remarketing atua de forma integrada entre Meta (Instagram) e Google para recuperar usuários interessados e aumentar a conversão</li>
                 <li>A estrutura é sempre adaptada ao cenário do cliente, respeitando produto, público e nível de maturidade do negócio</li>
                 <li>O objetivo é eficiência: reduzir custo por lead e aumentar previsibilidade de resultados</li>
               </ul>
               <p className="text-2xl font-bold text-center text-gray-900 bg-white border border-gray-200 py-6 rounded-xl shadow-sm">
                 Tudo opera como um ciclo contínuo de teste, aprendizado e escala.
               </p>
           </div>
           
           {/* SECAO 5: ESCOPO E MODELO DE ENTREGA */}
           <div className="p-20 break-after-page min-h-[1100px] mt-12 bg-white">
             
             <h2 className="text-4xl font-bold tracking-tight mb-12 pt-8 text-center">Escopo do que está incluso</h2>
             <p className="text-2xl mb-12 text-center text-gray-600">O sistema <strong style={{color: colorHex}}>{nomeAgencia}</strong> inclui:</p>
             
             <div className="grid grid-cols-2 gap-x-12 gap-y-8 mb-16 text-xl text-gray-800">
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Estrutura e gestão de tráfego pago (Meta e Google)</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Criação e otimização de campanhas</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Estrutura de remarketing integrada entre plataformas</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Produção de conteúdo base para redes sociais</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Criação de site focado em conversão</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Configuração de atendimento com IA no WhatsApp</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Estrutura inicial de qualificação de leads</span></div>
               <div className="flex gap-3 bg-gray-50 p-5 rounded-xl border border-gray-100"><span style={{color: colorHex}}>✓</span> <span className="font-medium">Ajustes e otimizações iniciais do sistema</span></div>
             </div>
             
             <div className="bg-black text-white px-10 py-8 rounded-2xl font-bold text-center text-2xl shadow-xl mb-24">
               Tudo dentro de uma estrutura única, padronizada e integrada.
             </div>

             <hr className="border-gray-200 mb-16" />

             <h2 className="text-4xl font-bold tracking-tight mb-8">Modelo de entrega e operação</h2>
             <div className="space-y-6 text-xl text-gray-700 leading-relaxed bg-white">
               <p>A <strong style={{color: colorHex}}>{nomeAgencia}</strong> trabalha com uma estrutura padronizada, otimizada por processos e automações.</p>
               <p>Isso permite entregar um sistema completo de forma mais rápida, organizada e eficiente.</p>
               <p>Nosso foco não está em aumentar margem sobre cada serviço, mas em criar uma operação escalável e repassar essa eficiência para o cliente.</p>
               <p>Por trás da operação existe um time, processos definidos e inteligência automatizada trabalhando em conjunto para garantir consistência na entrega.</p>
               
               <p className="font-bold text-gray-900 mt-10 p-8 bg-gray-50 rounded-xl border border-gray-200 shadow-sm text-center">
                 O resultado é um modelo mais simples para o cliente, sem abrir mão da qualidade e da evolução contínua do sistema.
               </p>
             </div>
           </div>

           {/* SECAO 6: INVESTIMENTO */}
           <div className="p-20 break-after-page min-h-[1100px] mt-12 bg-white text-gray-900 flex flex-col justify-center">
             
             <div className="border border-gray-200 rounded-3xl overflow-hidden mb-16 shadow-2xl">
               <div className="p-16 text-center text-white" style={{backgroundColor: colorHex}}>
                 <h2 className="text-5xl font-bold mb-4">Investimento</h2>
                 <p className="text-white/80 uppercase tracking-widest font-bold">Sistema {nomeAgencia}</p>
                 <div className="mt-8 text-8xl font-black">R$ 1.000<span className="text-3xl font-medium">/mês</span></div>
               </div>
               <div className="p-16 bg-gray-50">
                 <p className="font-black text-gray-900 text-xl mb-8 uppercase tracking-widest border-b pb-4">Incluindo:</p>
                 <ul className="space-y-6 text-2xl text-gray-800 mb-12 list-none">
                   <li className="flex items-center gap-4"><CheckSquare size={28} style={{color: colorHex}}/> Módulo Tráfego pago (Meta e Google)</li>
                   <li className="flex items-center gap-4"><CheckSquare size={28} style={{color: colorHex}}/> Módulo Conteúdo para redes sociais</li>
                   <li className="flex items-center gap-4"><CheckSquare size={28} style={{color: colorHex}}/> Módulo Site de conversão</li>
                   <li className="flex items-center gap-4"><CheckSquare size={28} style={{color: colorHex}}/> Módulo SDR com IA no WhatsApp</li>
                   <li className="flex items-center gap-4"><CheckSquare size={28} style={{color: colorHex}}/> Gestão e otimização contínua da estrutura</li>
                 </ul>
                 <p className="text-center italic text-gray-500 font-medium text-lg pt-8 border-t">
                   Um único investimento para acessar uma estrutura integrada de aquisição e atendimento digital.
                 </p>
               </div>
             </div>
             
             <div className="bg-gray-50 p-12 rounded-3xl border border-gray-200 shadow-sm">
               <h3 className="text-3xl font-bold tracking-tight mb-8 text-gray-900">Investimento em tráfego</h3>
               <div className="space-y-6 text-gray-700 text-xl leading-relaxed">
                 <p>Além da mensalidade da <strong style={{color: colorHex}}>{nomeAgencia}</strong>, existe o investimento em anúncios, pago diretamente às plataformas.</p>
                 <p>Esse valor não é fixo e varia de acordo com o mercado, concorrência, objetivos e velocidade de crescimento desejada.</p>
                 
                 <div className="bg-white p-6 rounded-xl border border-gray-200 my-8">
                   <p className="font-bold text-gray-900 mb-4">Como referência inicial, recomendamos investimentos a partir de:</p>
                   <ul className="list-disc list-inside space-y-2 ml-4 font-medium">
                     <li>R$ 30 por dia</li>
                     <li>R$ 100 por dia ou mais</li>
                   </ul>
                 </div>
                 
                 <p>Quanto maior o investimento, maior o potencial de alcance, geração de leads e velocidade de aprendizado das campanhas.</p>
                 <p>A definição do valor ideal será feita de acordo com a realidade e os objetivos de cada negócio.</p>
                 
                 <div className="mt-10 text-sm font-bold text-white uppercase tracking-wider bg-gray-900 p-6 rounded-xl text-center shadow">
                   Importante: o valor investido em anúncios é pago diretamente às plataformas e não está incluso na mensalidade da {nomeAgencia}.
                 </div>
               </div>
             </div>

           </div>

           {/* SECAO 7: COMPARATIVO E PROXIMOS PASSOS */}
           <div className="p-20 mt-12 bg-white text-gray-900 min-h-[1100px] flex flex-col justify-between pt-16">
              
              <div>
                <h2 className="text-4xl font-bold tracking-tight mb-16 text-center">Comparativo: Modelo Tradicional vs <span style={{color: colorHex}}>{nomeAgencia}</span></h2>

                <div className="flex border-2 border-gray-200 rounded-3xl overflow-hidden mb-16 shadow-xl">
                  <div className="w-1/2 p-12 bg-gray-50 border-r-2 border-gray-200 text-gray-800">
                    <h3 className="text-2xl font-bold mb-10 text-center text-gray-900 uppercase tracking-widest border-b-2 border-gray-200 pb-4">Modelo Tradicional</h3>
                    <ul className="space-y-8 text-lg font-medium">
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Serviços contratados separadamente</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Múltiplos fornecedores</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Foco em margem por serviço</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Processos manuais e descentralizados</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Pouca integração entre as áreas</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Custos acumulados por cada contratação</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Atendimento dependente de disponibilidade humana</li>
                      <li className="flex items-start gap-4"><X size={24} className="text-red-500 shrink-0 mt-1"/> Maior complexidade de gestão</li>
                    </ul>
                    
                    <div className="mt-12 p-8 bg-white border border-red-100 rounded-2xl shadow-sm text-gray-800">
                      <p className="font-bold mb-6 text-center uppercase tracking-widest text-red-600 border-b border-red-100 pb-4">Valor médio de mercado</p>
                      <ul className="space-y-4 text-base font-semibold text-center">
                        <li>Gestão Meta Ads: <span className="font-normal text-gray-600">R$ 800/mês</span></li>
                        <li>Social Media: <span className="font-normal text-gray-600">R$ 1.300 impl. + recor.</span></li>
                        <li>Site: <span className="font-normal text-gray-600">R$ 4.700 (impl. + mensal.)</span></li>
                      </ul>
                    </div>
                  </div>
                  
                  <div className="w-1/2 p-12 text-white relative flex flex-col" style={{backgroundColor: colorHex}}>
                    <h3 className="text-2xl font-bold mb-10 text-center uppercase tracking-widest border-b-2 border-white/20 pb-4">Sistema {nomeAgencia}</h3>
                    <ul className="space-y-8 text-lg font-medium text-white/95">
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Estrutura integrada em um único sistema</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Um único ponto de operação</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Foco em eficiência operacional</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Processos estruturados e automatizados</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Tráfego, conteúdo, site e atendimento conectados</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Estrutura unificada com investimento simplificado</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Atendimento inicial automatizado com IA</li>
                      <li className="flex items-start gap-4"><CheckSquare size={24} className="text-green-400 shrink-0 mt-1"/> Operação centralizada e mais simples</li>
                    </ul>
                    
                    <div className="mt-auto pt-8 flex-1 flex flex-col justify-end">
                      <div className="p-8 bg-black/20 rounded-2xl backdrop-blur-md text-center border border-white/10">
                        <p className="font-bold mb-4 uppercase text-sm tracking-widest text-white/60">Sistema {nomeAgencia}</p>
                        <ul className="space-y-2 text-base font-medium mb-6 inline-block text-left text-white/90">
                          <li>✓ Tráfego Meta/Google Ads</li>
                          <li>✓ Conteúdo, Site, SDR c/ IA</li>
                          <li>✓ Operação integrada</li>
                        </ul>
                        <div className="text-4xl font-black pt-6 border-t border-white/20">R$ 1.000/mês</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-4xl font-bold tracking-tight mb-12 text-center">Próximos passos</h2>

                <div className="grid grid-cols-5 gap-6">
                    <div className="flex flex-col items-center">
                      <div className="w-16 h-16 rounded-2xl flex items-center justify-center font-black text-2xl mb-6 shadow-md" style={{backgroundColor: colorHex, color: 'white'}}>1</div>
                      <h4 className="font-bold text-center text-lg mb-4 text-gray-900 border-b-2 border-gray-200 pb-2">Aprovação</h4>
                      <p className="text-center text-sm text-gray-600 leading-relaxed">Após a aprovação, iniciamos o processo de implantação da estrutura.</p>
                    </div>
                    
                    <div className="flex flex-col items-center">
                      <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center font-black text-xl mb-6 border border-gray-200 text-gray-400">2</div>
                      <h4 className="font-bold text-center text-lg mb-4 text-gray-900 border-b-2 border-gray-200 pb-2">Alinhamento</h4>
                      <p className="text-center text-sm text-gray-600 leading-relaxed">Entender o negócio, público, diferenciais e objetivos da operação.</p>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center font-black text-xl mb-6 border border-gray-200 text-gray-400">3</div>
                      <h4 className="font-bold text-center text-lg mb-4 text-gray-900 border-b-2 border-gray-200 pb-2">Configuração</h4>
                      <p className="text-center text-sm text-gray-600 leading-relaxed">Estruturamos tráfego, redes sociais, site e IA.</p>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center font-black text-xl mb-6 border border-gray-200 text-gray-400">4</div>
                      <h4 className="font-bold text-center text-lg mb-4 text-gray-900 border-b-2 border-gray-200 pb-2">Ativação</h4>
                      <p className="text-center text-sm text-gray-600 leading-relaxed">Iniciamos as campanhas, ativações e integrações necessárias.</p>
                    </div>

                    <div className="flex flex-col items-center">
                      <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center font-black text-xl mb-6 border border-gray-200 text-gray-400">5</div>
                      <h4 className="font-bold text-center text-lg mb-4 text-gray-900 border-b-2 border-gray-200 pb-2">Evolução</h4>
                      <p className="text-center text-sm text-gray-600 leading-relaxed">Testes, otimizações e melhorias contínuas.</p>
                    </div>
                </div>
                
                <div className="mt-20 pt-8 flex justify-between items-center font-mono text-sm uppercase tracking-widest text-gray-400" style={{ borderTop: `4px solid ${colorHex}` }}>
                  <div className="flex flex-col gap-2">
                    <span className="font-bold text-gray-900">{nomeAgencia}</span>
                    <span>{cnpj}</span>
                  </div>
                  <div className="flex flex-col gap-2 items-end text-right">
                    <span>{contato}</span>
                    <span className="lowercase">{email}</span>
                  </div>
                </div>
              </div>

           </div>

        </div>
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
            padding: 0;
          }
          body * {
             display: none;
             visibility: hidden;
             margin: 0;
             padding: 0;
             background-color: white;
          }
          #root {
             display: block !important;
             visibility: visible !important;
             background-color: white !important;
          }
          .no-print {
             display: none !important;
          }
          .printable-document {
             width: 210mm !important;
             display: block !important;
             visibility: visible !important;
             background-color: white !important;
             margin: 0 !important;
             padding: 0 !important;
             box-shadow: none !important;
          }
          .printable-document * {
             visibility: visible;
             display: flex;
          }
          .printable-document div,
          .printable-document h1, .printable-document h2, .printable-document h3, .printable-document h4, .printable-document h5, .printable-document h6,
          .printable-document p, .printable-document ul, .printable-document li, .printable-document span, .printable-document a, .printable-document img {
             display: block;
          }
          .printable-document .flex {
             display: flex !important;
          }
          .printable-document .grid {
             display: grid !important;
          }
          .printable-document .hidden {
             display: none !important;
          }
          .break-after-page {
             page-break-after: always !important;
             break-after: page !important;
          }
        }
      `}} />
    </div>
  );
};
